import { flexRender } from '@tanstack/react-table';


export const TableBody = ({ table, onRowClick }) => (
  <tbody>
    {table.getRowModel().rows.map((row) => (
      <tr
        key={row.id}
        onClick={() => onRowClick?.(row.original)}
        className="hover:bg-white/10 transition-colors border-b border-white/5 cursor-pointer"
      >
        {row.getVisibleCells().map((cell) => (
          <td key={cell.id} className="px-4 py-3 text-white/70 text-xs">
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </td>
        ))}
      </tr>
    ))}
  </tbody>
);
